<template>
  <div class="spain-bottom-content">
    <div class="container">
      <transition name="fade">
        <div v-if="history[currentStep].name === 'loan_purpose'" class="spain-bottom-content__policies">
          <a href="/terms.pdf" target="_blank">Términos y condiciones</a>
          <span> | </span>
          <a href="/privacy-policy.pdf" target="_blank">Política de privacidad</a>
        </div>
        <div v-else-if="history[currentStep].name === 'phone'" class="spain-bottom-content__disclaimer">
          <p>Para completar la solicitud de préstamo y encontrar una oferta de préstamo adecuada para usted, compartimos los datos personales proporcionados en este formulario con nuestros socios: instituciones de crédito y corredores de crédito (todos o solo algunos de ellos, a discreción de Fininity OÜ). La lista completa de estos socios está disponible a través del siguiente <a href="/partners-list.pdf" target="_blank">enlace</a>.</p>
          <p>El responsable del tratamiento de sus datos personales es Fininity OÜ. Los servicios en este sitio son proporcionados por Fininity OÜ.</p>
          <p>Este sitio web es propiedad y está operado por Fininity OÜ. Puede ponerse en contacto con nosotros por correo electrónico a compliance@{{hostname}}.</p>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'EsBottomContent',
  data () {
    return {
      hostname: document.location.hostname,
    }
  },
  computed: {
    ...mapState({
      history: state => state.history,
      currentStep: state => state.currentStep
    })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.spain-bottom-content {
  padding-top: 30px;
  margin: auto 0 -40px 0;
  color: var(--white);

  &__policies {
    font-size: 14px;

    @media (max-width: 374px) {
      font-size: 12px;
    }
  }

  &__disclaimer {
    font-size: 12px;
    opacity: 0.75;

    @media (max-width: 767px) {
      text-align: left;
    }
  }

  a {
    font-weight: 700;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hardcoreComponents/EsBottomContent.vue